import React from "react";
import { Button } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ARROW_CLASS = "border-0 shadow-sm txt-main bg-surface d-flex align-items-center justify-content-center p-0";
const ARROW_STYLE = { borderRadius: "6px", width: "26px", height: "26px", flexShrink: 0 };

const CalendarNavigation = ({ label, onPrevious, onNext, onToday }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center gap-1" style={{ flex: "1 1 auto", minWidth: 0 }}>
      <Button
        variant="light"
        size="sm"
        onClick={onPrevious}
        className={ARROW_CLASS}
        style={ARROW_STYLE}
        aria-label={t("components.Calendar.previous")}
      >
        <FaChevronLeft size={10} />
      </Button>

      <span
        className="fw-bold txt-main text-capitalize text-center px-1"
        style={{ fontSize: "0.85rem", minWidth: 0, maxWidth: "160px" }}
      >
        {label}
      </span>

      <Button
        variant="light"
        size="sm"
        onClick={onNext}
        className={ARROW_CLASS}
        style={ARROW_STYLE}
        aria-label={t("components.Calendar.next")}
      >
        <FaChevronRight size={10} />
      </Button>

      <Button
        variant="outline-secondary"
        size="sm"
        onClick={onToday}
        className="ms-1 fw-bold py-0 px-2"
        style={{ borderRadius: "6px", height: "26px", fontSize: "0.75rem", flexShrink: 0 }}
      >
        {t("components.Calendar.today")}
      </Button>
    </div>
  );
};

export default CalendarNavigation;
